import { defineMessages } from "react-intl"

export const messages = defineMessages({
    registerModalHeader: {
        id: "payment-processing.terminal-listing.register-terminal-modal.header",
        defaultMessage: "Add new terminal",
    },
    detailsModalHeader: {
        id: "payment-processing.terminal-listing.terminal-details-modal.header",
        defaultMessage: "Terminal details",
    },
    deviceRegistrationCodeLabel: {
        id: "payment-processing.terminal-listing.register-terminal-modal.device-registration-code",
        defaultMessage: "Device registration code",
    },
    deviceRegistrationCodePlaceholder: {
        id: "payment-processing.terminal-listing.register-terminal-modal.device-registration-code-placeholder",
        defaultMessage: "Enter device registration code",
    },
    deviceRegistrationCodeTestModePlaceholder: {
        id: "payment-processing.terminal-listing.register-terminal-modal.device-registration-code-test-mode-placeholder",
        defaultMessage: "VIRTUAL_DEVICE",
    },
    deviceRegistrationCodeMissing: {
        id: "payment-processing.terminal-listing.register-terminal-modal.device-registration-code-missing",
        defaultMessage: "Please enter a valid registration code",
    },
    deviceRegistrationCodeHint: {
        id: "payment-processing.terminal-listing.register-terminal-modal.device-registration-code-hint",
        defaultMessage: "The registration code can be found on the physical device that you wish to pair.",
    },
    deviceNameLabel: {
        id: "payment-processing.terminal-listing.register-terminal-modal.device-name",
        defaultMessage: "Device name",
    },
    deviceNamePlaceholder: {
        id: "payment-processing.terminal-listing.register-terminal-modal.device-name-placeholder",
        defaultMessage: "Enter device name",
    },
    deviceNameMissing: {
        id: "payment-processing.terminal-listing.register-terminal-modal.device-name-missing",
        defaultMessage: "Please enter a valid device name",
    },
    deviceNameHint: {
        id: "payment-processing.terminal-listing.register-terminal-modal.device-name-hint",
        defaultMessage: "The name can be anything that helps you easily identify the physical device. (max. 20 chars)",
    },
    registerModalClose: {
        id: "payment-processing.terminal-listing.register-terminal-modal.close",
        defaultMessage: "Close",
    },
    registerModalSubmit: {
        id: "payment-processing.terminal-listing.register-terminal-modal.add",
        defaultMessage: "Add",
    },
    detailsModalDeleteBtn: {
        id: "payment-processing.terminal-listing.terminal-details-modal.delete-btn",
        defaultMessage: "Delete",
    },
    detailsModalConfirmDeleteBtn: {
        id: "payment-processing.terminal-listing.terminal-details-modal.confirm-delete-btn",
        defaultMessage: "Yes",
    },
    detailsModalCancelDeleteBtn: {
        id: "payment-processing.terminal-listing.terminal-details-modal.cancel-delete-btn",
        defaultMessage: "No",
    },
    detailsModalCloseBtn: {
        id: "payment-processing.terminal-listing.terminal-details-modal.close-btn",
        defaultMessage: "Close",
    },
    detailsModalResetBtn: {
        id: "payment-processing.terminal-listing.terminal-details-modal.reset-btn",
        defaultMessage: "Reset Terminal",
    },
    detailsModalConfirmDelete: {
        id: "payment-processing.terminal-listing.terminal-details-modal.confirm-delete",
        defaultMessage: "Are you sure?",
    },
    detailsModalResetTooltip: {
        id: "payment-processing.terminal-listing.terminal-details-modal.reset-tooltip",
        defaultMessage: "Resetting a terminal will cancel any payment presented on it and set it as available.",
    },
    deviceNameHeader: {
        id: "payment-processing.terminal-listing.terminal-details-modal.device-name-header",
        defaultMessage: "Device Name",
    },
    brandAndModelHeader: {
        id: "payment-processing.terminal-listing.terminal-details-modal.brand-and-model-header",
        defaultMessage: "Brand & Model",
    },
    terminalIdHeader: {
        id: "payment-processing.terminal-listing.terminal-details-modal.terminal-id-header",
        defaultMessage: "Terminal ID",
    },
    deviceRegistrationIdHeader: {
        id: "payment-processing.terminal-listing.terminal-details-modal.device-registration-id-header",
        defaultMessage: "Device Registration ID",
    },
    serialNumberHeader: {
        id: "payment-processing.terminal-listing.terminal-details-modal.serial-number-header",
        defaultMessage: "Serial Number",
    },
    statusHeader: {
        id: "payment-processing.terminal-listing.terminal-details-modal.status-header",
        defaultMessage: "Status",
    },
    pairedDateHeader: {
        id: "payment-processing.terminal-listing.terminal-details-modal.paired-date-header",
        defaultMessage: "Paired Date",
    },
    paymentAccountHeader: {
        id: "payment-processing.terminal-listing.terminal-details-modal.payment-account-header",
        defaultMessage: "Payment Account ID",
    },
})


// WEBPACK FOOTER //
// ./src/payment-processing/modals/TerminalMessages.ts